var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.25C25 22.5 20.625 25.625 15.425 27.4375C15.1527 27.5298 14.8569 27.5254 14.5875 27.425C9.375 25.625 5 22.5 5 16.25V7.50001C5 7.16849 5.1317 6.85055 5.36612 6.61613C5.60054 6.38171 5.91848 6.25001 6.25 6.25001C8.75 6.25001 11.875 4.75001 14.05 2.85001C14.3148 2.62376 14.6517 2.49945 15 2.49945C15.3483 2.49945 15.6852 2.62376 15.95 2.85001C18.1375 4.76251 21.25 6.25001 23.75 6.25001C24.0815 6.25001 24.3995 6.38171 24.6339 6.61613C24.8683 6.85055 25 7.16849 25 7.50001V16.25Z",
    stroke: "#70BDA3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15L13.75 17.5L18.75 12.5",
    stroke: "#70BDA3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.29a8ac16a32d11449c9abfc0b7f035d1.svg";
export { ForwardRef as ReactComponent };